import type { TicketDto } from "@/api/tickets";

export type TicketResolutionSession = {
  id: number;
  scopeKey: string | undefined;
  ticket: TicketDto;
  isPending: boolean;
  error: unknown;
};

type SessionAction =
  | { type: "open"; session: TicketResolutionSession }
  | { type: "scope"; scopeKey: string | undefined }
  | { type: "submit" | "close" | "settle"; sessionId: number }
  | { type: "error"; sessionId: number; error: unknown; ticket?: TicketDto };

export function activeResolutionSession(session: TicketResolutionSession | null, scopeKey: string | undefined): TicketResolutionSession | null {
  return session?.scopeKey === scopeKey ? session : null;
}

/** 异步响应只操作发起请求的那次表单，避免旧工单的响应关闭或改写新表单。 */
export function ticketResolutionSessionReducer(session: TicketResolutionSession | null, action: SessionAction): TicketResolutionSession | null {
  if (action.type === "open") return action.session;
  if (action.type === "scope") return activeResolutionSession(session, action.scopeKey);
  if (!session || session.id !== action.sessionId) return session;

  switch (action.type) {
    case "close":
      return null;
    case "submit":
      return { ...session, isPending: true, error: null };
    case "settle":
      return { ...session, isPending: false };
    case "error":
      return { ...session, error: action.error, ticket: action.ticket ?? session.ticket };
  }
}
